/* eslint-disable @typescript-eslint/naming-convention */
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

export const environment = {
  production: true,
  showConsoleLogs: false,
  enableServiceWorker: true,
  serviceWorkerUpdateCheckTime: 24 * 3600 * 1000,
  websocketEndpoint: 'wss://websocket-prod.naistro.com',
  apiEndpoint: 'https://api-prod.naistro.com/players',
  audioCdn: 'https://cdn-gate-production.naistro.com/audio',
  apiEndpointParams: {
    test: false,
  },
  apiKey: 'a2CV9oQ0oND3unseTyFB2daK2iEHeUX4bpojrXP5',
  googleMapsKey: 'AIzaSyCNaCYzdMwgzlwRZS2K8lzBLWTeF0JMVBE',
  amplifyConfig: {
    Auth: {
      region: 'eu-west-1',
      identityPoolId: 'eu-west-1:f41dff97-3ed3-478f-9692-79f80aed00ba',
      userPoolId: 'eu-west-1_G5rHcoeuQ',
      userPoolWebClientId: '3i2edjm6kujd0qt27t41dfefs9',
      authenticationFlowType: 'USER_SRP_AUTH',
      mandatorySignIn: false,
    },
  },
  /** API refresh time for the player. */
  sync: 1000 * 60 * 5,
  publicSiteUrl: 'https://www.naistro.com',
    imports: [
    StoreDevtoolsModule.instrument({
      name: 'Naistro Player State',
      maxAge: 150,
      actionsBlocklist: ['[Logs]', '[Storage]'],
    }),
  ],
  hostname: 'app.naistro.com'
};

// import { StoreDevtoolsModule } from '@ngrx/store-devtools';

// export const environment = {
//   production: true,
//   showConsoleLogs: false,
//   enableServiceWorker: true,
//   serviceWorkerUpdateCheckTime: 24 * 3600 * 1000,
//   websocketEndpoint: 'wss://websocket-test.naistro.com',
//   apiEndpoint: 'https://api-test.naistro.com/players',
//   audioCdn: 'https://cdn-gate-testing.naistro.com/audio',
//   apiEndpointParams: {
//     test: false,
//   },
//   apiKey: '7wCNQBWpkh3iKlNLk7ikQ3Dwss1Wrsdf2Ul5Vv6N',
//   googleMapsKey: 'AIzaSyCNaCYzdMwgzlwRZS2K8lzBLWTeF0JMVBE',
//   amplifyConfig: {
//     Auth: {
//       region: 'eu-west-1',
//       identityPoolId: 'eu-west-1:79a797d7-234f-4179-be50-9e5e547cccbb',
//       userPoolId: 'eu-west-1_UIaQXHA9F',
//       userPoolWebClientId: '4gjd2aa3taveprg71n1g1b4m4o',
//       authenticationFlowType: 'USER_SRP_AUTH',
//       mandatorySignIn: false,
//     },
//   },
//   /** API refresh time for the player. */
//   sync: 1000 * 60 * 5,
//   publicSiteUrl: 'https://test.naistro.com',
//   imports: [
//     StoreDevtoolsModule.instrument({
//       name: 'Naistro Player State',
//       maxAge: 150,
//       actionsBlocklist: ['[Logs]', '[Storage]'],
//     }),
//   ],
//   hostname: 'app-test.naistro.com'
// };

// import { StoreDevtoolsModule } from '@ngrx/store-devtools';

// export const environment = {
//   production: false,
//   showConsoleLogs: true,
//   enableServiceWorker: false,
//   serviceWorkerUpdateCheckTime: 30 * 1000,
//   websocketEndpoint: 'wss://websocket-dev.naistro.com',
//   apiEndpoint: 'https://api-dev.naistro.com/players',
//   audioCdn: 'https://cdn-gate-dev.naistro.com/audio',
//   apiEndpointParams: {
//     test: false,
//     prayerDurationInMilliseconds: 30000,
//     silenceDurationInMilliseconds: 30000,
//   },
//   apiKey: 'o4PBtizoSs1meRjfgXohv9H0nMowRuTA4CNraECW',
//   googleMapsKey: 'AIzaSyCNaCYzdMwgzlwRZS2K8lzBLWTeF0JMVBE',
//   amplifyConfig: {
//     Auth: {
//       region: 'eu-west-1',
//       identityPoolId: 'eu-west-1:24e68dbe-159f-47c2-b19f-344cdc1fb73c',
//       userPoolId: 'eu-west-1_O9xcPaG24',
//       userPoolWebClientId: '4ffgfe9g364gep939ip6bj72u5',
//       authenticationFlowType: 'USER_SRP_AUTH',
//       mandatorySignIn: false,
//     },
//   },
//   /** API refresh time for the player. */
//   sync: 1000 * 60 * 5,
//   publicSiteUrl: 'https://dev.naistro.com',
//   imports: [
//     StoreDevtoolsModule.instrument({
//       name: 'Naistro Player State',
//       maxAge: 150,
//       actionsBlocklist: ['[Logs]', '[Storage]'],
//     }),
//   ],
// };

